import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
const { Option } = Select;

// When `options` is supplied the caller owns the list (e.g. options derived from
// the rows actually shown in a table); the component then skips its own fetch.
const VehicleManufacturerSelect = ({ segmentId, value, onChange, disabled = false, multiple = false, options, optionsLoading = false }) => {

  const isControlledList = Array.isArray(options);

  const { request } = useRequest();
  const [manufacturerList, setManufacturerList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchManufacturers = async () => {
    setLoading(true);

    let url = apiPath.commonManufacturer;
    if (segmentId) {
      url += `?segment_id=${segmentId}`;
    }

    request({
      url,
      method: "GET",
      onSuccess: (res) => {
        const manufacturers = res?.data?.data || [];
        setManufacturerList(manufacturers);
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err?.response?.data?.message || "Failed to load manufacturers", Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    if (isControlledList) return;
    fetchManufacturers();
  }, [segmentId, isControlledList]);

  const list = isControlledList ? options : manufacturerList;
  const isLoading = isControlledList ? optionsLoading : loading;

  return (
    <Spin spinning={isLoading} tip="Loading manufacturers..." size="small">
      <Select
        mode={multiple ? "multiple" : undefined}
        showSearch
        allowClear
        placeholder="Select manufacturer"
        optionFilterProp="children"
        value={value}
        onChange={(val, option) => onChange?.(val, option)}
        disabled={disabled}
        loading={isLoading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={{ height: 40 }}
      >
        {list?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default VehicleManufacturerSelect;
